<template>
  <div class="is-overlay has-bg-light" style="min-height: 100vh">
    <!-- <spinner-round :isLoading="loading"></spinner-round> -->
    <div class="columns is-border has-bg-white login" v-if="!loading" style="min-height: 559px">
      <div class="column login-cover is-8"
           :style="[illustrationStyle]">
      </div>
      <div class="column is-4 columns is-gapless is-column is-paddingless-bottom">
        <img :src="$configs.LOGO_LOGIN" width="100%" :alt="$configs.COMPANY">
        <form @submit.prevent.stop="login()" class="is-margin-top-large is-margin-bottom-small">
          <div class="field">
            <div class="control">
              <v-input id="email" name="email" @input="val => email = val" :model="email"
                       label="Email *"
                       v-validate="'required|email'" :errors-bag="errors" data-vv-value-path="val"
                       data-vv-as="Email" data-type-cy="input" data-value-cy="login_email">
              </v-input>
            </div>
          </div>
          <div class="field">
            <div class="control has-icons-right">
              <v-input :classes="'password'" id="password" name="password" @input="val => password = val"
                       :model="password"
                       label="Mot de Passe *" :input-type="displayPassword ? 'text' : 'password'"
                       v-validate="'required|min:6'" :errors-bag="errors" data-vv-value-path="val"
                       data-vv-as="Password" :icon="' '" data-type-cy="input" data-value-cy="login_password">
                <p class="control">
                  <a class="button is-square is-radiusless" @click="displayPassword = !displayPassword"
                     data-type-cy="link" data-value-cy="see_password">
                    <i class="fal" :class="!displayPassword ? 'fa-eye' : 'fa-eye-slash'" data-type-cy="icon"
                       data-value-cy="see_password"></i>
                  </a>
                </p>
              </v-input>
            </div>
          </div>
          <button type="submit" class="is-margin-top button is-brand is-fullwidth"
                  :disabled="!canSubmit || loading || !apiReady" :class="{'is-loading':loading}" data-type-cy="button"
                  data-value-cy="login_submit">
            <span v-if="!loading">Login</span>
          </button>
        </form>
        <div class="is-clearfix">
          <p class="is-pulled-left">
            <router-link :to="{name: 'ResetPassword'}" class="has-text-grey is-size-6" data-type-cy="link"
                         data-value-cy="reset_password">Mot de passe oublié ?
            </router-link>
          </p>
        </div>
        <div class="is-margin-top-auto ">
          <div class="columns is-gapless is-align-items-flex-end">
            <div class="column is-narrow">
              <img src="static/logo-vadimm--x2.png" width="60" alt="">
            </div>
            <div class="column is-margin-bottom-xsmall">
              <p class="has-text-right has-text-grey is-size-7">
                <small>V. {{appVersion}}</small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { isNil } from 'lodash'
  import { mapGetters, mapState } from 'vuex'
  import { bus, EVENTS } from '@/services/bus/index.js'
  import jwtDecode from 'jwt-decode'

  export default {
    name: 'AppLogin',
    data () {
      return {
        email: '',
        password: '',
        loading: false,
        displayPassword: false
      }
    },
    computed: {
      ...mapState(['apiReady']),
      ...mapGetters(['isLog']),
      appVersion () {
        return process.env.npm_package_version
      },
      canSubmit () {
        return this.errors.any() === false && isNil(this.password) === false && isNil(this.email) === false
      },
      illustrationStyle () {
        let styleObject = {}
        if (this.apiReady && this.$configs && this.$configs.ILLUSTRATION_LOGIN && this.$configs.ILLUSTRATION_LOGIN !== '') {
          styleObject.backgroundImage = 'url(\' ' + this.$configs.ILLUSTRATION_LOGIN + ' \')'
        } else {
          //  styleObject.color = 'white'
          styleObject.backgroundImage = 'url(\'https://res.cloudinary.com/batiment-b/image/upload/v1585037058/vadimm-src/login-illustration-min.jpg\')'
        }
        return styleObject
      }
    },
    methods: {
      tokenReceived (data) {
        localStorage.setItem('token', data.token)
        this.$api.setToken(data.token)
        this.$store.commit('login', {userId: data.user_pk, user: jwtDecode(data.token)})
        let from = localStorage.getItem('redirectAfterLogin')
        if (from) {
          this.$router.push(from)
        } else {
          this.$router.push({name: 'Home'})
        }
        localStorage.removeItem('redirectAfterLogin')
        bus.$emit(EVENTS.LOGIN, data.user_pk)
      },
      login () {
        this.validate((valid) => {
          this.loading = true
          this.$api.authService.login(this.email, this.password).then(r => {
            this.loading = false
            this.tokenReceived(r.data)
          }).catch(r => {
            this.loading = false
            this.$notify({
              type: 'is-danger',
              text: 'Erreur. Veuillez vérifier vos identifiants'
            })
          })
        })
      },
      jwtExpired (jwt) {
        const decoded = jwtDecode(jwt)
        if (!decoded) {
          return true
        }
        let expired = false
        if (!decoded) {
          expired = true
        } else {
          expired = decoded.exp < Date.now() / 1000
        }
        return expired
      },
      validate (cb) {
        this.$validator.validateAll().then((result) => {
          cb(result)
        })
      }
    },
    created () {
      if (this.$route.query.token && this.$route.query.email) {
        // this.resetPasswordModalActive = true
        this.$router.push({
          name: 'ResetPassword',
          query: {token: this.$route.query.token, email: this.$route.query.email}
        })
      }
      if (this.$route.query.email) {
        this.email = this.$route.query.email
      }
    },
    mounted () {
      if (this.$route.query.token) {
        setTimeout(() => {
          this.tokenReceived({ ...jwtDecode(this.$route.query.token), token: this.$route.query.token })
        }, 200)
      }
      if (this.isLog && !this.jwtExpired(localStorage.getItem('token'))) {
        this.$notify({
          type: 'is-warning',
          text: 'Vous êtes déjà connecté.'
        })
        this.$router.replace({name: 'Home'})
      }

      // if (localStorage.getItem('token') && this.jwtExpired(localStorage.getItem('token'))) {
      // if (!localStorage.getItem('token')) {
      //   localStorage.removeItem('token')
      //   this.$store.commit('logout')
      //   this.$store.commit('initState')
      //   this.$notify({
      //     type: 'is-warning',
      //     text: 'Veuillez vous connecter'
      //   })
      //   this.$router.replace({name: 'Login', force: true})
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/login/AppLogin.vue